import * as React from "react";
import { useState } from "react";
import { Slider, Tooltip } from "@nextui-org/react";
import Size from "../../components/Size";
import Hint from "../../components/Hint";

const GameplayView = (props) => {
  const [value, setValue] = useState(0);
  const [inputValue, setInputValue] = useState("0");


  const formatDistanceTooltipContent = (distanceInLY) => {
    const distanceInKm = distanceInLY * oneLightYearInKm;
    return `${distanceInLY.toFixed(6)} lightyears ≈ ${distanceInKm.toExponential(3)} km`;
  };

  const oneLightYearInKm = 9.461e12; // Conversion factor (lightyears to kilometers)

  return (
    <div className="mx-auto max-w-screen-lg px-4 lg:px-2">
      <h1 className="text-3xl text-center pb-4">
        <b>Round {props.round}</b> - {props.planet.name}
      </h1>

      <div className="flex flex-col lg:flex-row justify-between items-end">
        <div className="lg:w-1/2 lg:pr-8">
          <div className="flex flex-col gap-4">
            <img
              src={props.planet.imgSrc.img}
              alt={props.planet.imgSrc.imgDescription}
              className="mx-auto w-full lg:max-w-md"
            />
            <p className="text-justify">{props.planet.description}</p>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div className="flex items-center">
                <p className="font-orbitron pr-1">Temperature: </p>{" "}
                {props.kelvinToCelsius(props.planet.temperature)}°C
              </div>
              <div className="flex items-center">
                <p className="font-orbitron pr-1">Mass: </p>{" "}
                {props.calculateMass(props.planet.mass)} kg
              </div>
              <div className="flex items-center">
                <p className="font-orbitron pr-1">Period: </p>{" "}
                {props.planet.period} days
              </div>
              <div className="flex items-center">
                <p className="font-orbitron pr-1">Gravity: </p>{" "}
                {props.calculateGravity(props.planet.mass, props.planet.radius)}{" "}
                m/s²
              </div>
            </div>
          </div>
        </div>

        <div className="lg:w-1/2 lg:pl-8">
          <div className="relative flex flex-col gap-8 lg:items-start border-medium rounded-medium p-6 m-5 max-w-full">
            <h2 className="absolute bg-black top-0 transform -translate-y-1/2 px-2">
              <b>Planet Quiz:</b>
            </h2>
            <p className="text-center lg:text-left">
              Guess the radius from {props.planet.name} in comparison to Earth .
              Just use the slider to give your guess.
            </p>
            <div className="w-full mb-8">
              <Size onChange={props.onSizeChange} />
            </div>
            <p className="text-center lg:text-left">
              Guess the distance from Earth to {props.planet.name}. Just use the
              slider to give your guess.
            </p>

            <div className="flex items-center gap-4 w-full">
              <img
                src="/assets/images/earth.png"
                alt="earth"
                className="h-10 translate-y-4"
              />
              <Slider
                label="Distance in Lightyears"
                size="md"
                step={0.000001}
                maxValue={0.000478}
                minValue={0}
                color="foreground"
                classNames={{
                  base: "max-w-md w-full mx-auto",
                  label: "text-medium font-sen mr-4",
                }}
                value={value}
                onChange={changeDistanceACB}
                renderValue={({ children, ...props }) => (
                  <output {...props}>
                    <Tooltip
                      className="text-tiny text-default-500 rounded-lg"
                      content={formatDistanceTooltipContent(value)}
                      placement="left"
                    >
                      <input
                        className="px-1 py-0.5 w-20 text-right text-small text-default-700 font-medium bg-default-100 outline-none transition-colors rounded-small border-medium border-transparent hover:border-primary focus:border-primary"
                        type="text"
                        aria-label="lightyears"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !isNaN(Number(inputValue))) {
                            setValue(Number(inputValue));
                          }
                        }}
                      />
                    </Tooltip>
                  </output>
                )}
              />
            </div>
          </div>
          <div className="flex lg:flex-row flex-col items-center lg:items-start justify-end lg:mr-5 gap-4">
            <Hint
              text="Or press spacebar to go to the next round!"
              icon="/assets/images/keys/Spacebar.png"
              function={props.toResults}
              condition={props.round === 1}
            />
            <button
              className={`btn-primary mt-8 lg:mt-0 w-full lg:w-auto h-fit`}
              onClick={props.toResults}
              // disabled={
              //   !props.guessedValues.size || !props.guessedValues.distance
              // }
            >
              Guess
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  function changeDistanceACB(value) {
    if (isNaN(Number(value))) return;
    setValue(value);
    setInputValue(value.toString());
    props.onSliderChange(value);
  }
};

export default GameplayView;
